import React, { Component } from 'react';
import "./Resume.css";

class RightHeader extends Component {
    render() {
        return (
            <div className="col-md-4 right_header text-right">
                <strong>
                    <a href="mailto:7703776266@txt.att.net?Subject=Resume%20Text%20Message" target="_top">770-377-6266</a><br/>
                    <a href="mailto:Charles.Roberts@gatech.edu?Subject=Your%20Resume" target="_top">Charles.Roberts@GaTech.edu</a><br/>
                    <a href="https://www.charles-w-roberts.com/" target="_blank" rel="noopener noreferrer" className="header_p">www.Charles-W-Roberts.com</a>
                    
                </strong>
            </div>
        )
    }
}

export default RightHeader;


// WEBPACK FOOTER //
// ./src/components/Resume/RightHeader.js